import { Injectable, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { OnAppInit } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LazySportsConfigLoaderService implements OnAppInit {
    sitecore = inject(Sitecore);

    async onAppInit(): Promise<any> {
        await firstValueFrom(this.sitecore.whenReady);
    }
}
